if (!customElements.get('pc-footer-wordmark')) {
  class PcFooterWordmark extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('span');
      if (!this.text) return;
      this.fit();
      this.classList.add('pc-footer__wordmark--ready');
      this.resizeObserver = new ResizeObserver(() => this.fit());
      this.resizeObserver.observe(this);
      document.fonts.ready.then(() => { if (this.isConnected) this.fit(); });
      this.visibilityObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.classList.add('pc-footer__wordmark--visible');
          this.visibilityObserver.disconnect();
        }
      }, { threshold: 0.15 });
      this.visibilityObserver.observe(this);
    }
    fit() {
      const width = this.clientWidth;
      if (!width) return;
      this.text.style.fontSize = '100px';
      const measured = this.text.getBoundingClientRect().width;
      if (!measured) return;
      const size = 100 * width / measured;
      this.text.style.fontSize = `${size}px`;
      this.style.setProperty('--pc-wordmark-crop', `${size * 0.55}px`);
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
    }
  }
  customElements.define('pc-footer-wordmark', PcFooterWordmark);
}
